import type { DropdownOption } from './MultiSelectDropdown'

export function isDropdownOption(value: string | DropdownOption): value is DropdownOption {
  return (value as DropdownOption).value !== undefined
}
